export const filterOptions = [
  { optionId: "1", optionLabel: "Bank Withdraw" },
  { optionId: "2", optionLabel: "Virtual Account Deposit" },
  { optionId: "3", optionLabel: "Deal Purchase" },
  { optionId: "4", optionLabel: "Deal Repayment" },
];
